module.exports = __webpack_public_path__ + "static/media/soldier.4f0cc921.jpg";